import numeral from 'numeral';
import { Component } from 'react';

class ExtraBox extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <>
                <div className="table-header-subtitle">
                    <div>
                        Google organizes content into both Categories and Entities to align with
                        user interests before it appears in Google Discover. Categories, also known
                        as "Content Classifiers" or "Ontology," are standardized labels that Google
                        uses across its products—Search, Discover, Ads, Trends, Shopping, and
                        more—to categorize content. For simplicity, we refer to these as
                        "Categories." You can view the full list of categories{' '}
                        <a
                            className="text-muted"
                            target="_blank"
                            rel="noreferrer"
                            href="https://cloud.google.com/natural-language/docs/categories?hl=en"
                        >
                            here.
                        </a>
                    </div>
                    <div className="mt-10">
                        Based On you average performance We Have Identified Your Top Strong, Weak
                        And Striking Distance Categories. For Your Top Level Categories, Your
                        Average Performance Is:
                        <div className="table-header-subtitle-boxes">
                            <div className="table-header-subtitle-boxes-container">
                                <div>
                                    <img src="/static/img/file-05.svg" alt="img" />
                                </div>
                                <div className="table-header-subtitle-boxes-info">
                                    Pages/Category
                                    <div className="table-header-subtitle-boxes-numbers">
                                        {numeral(this.props.avgPages).format('0.0a')}
                                    </div>{' '}
                                </div>
                            </div>
                            <div className="table-header-subtitle-boxes-container">
                                <div>
                                    <img src="/static/img/cursor-box.svg" alt="img" />
                                </div>
                                <div className="table-header-subtitle-boxes-info">
                                    CTR
                                    <div className="table-header-subtitle-boxes-numbers">
                                        {numeral(this.props.avgCTR).format('0.000%')}
                                    </div>{' '}
                                </div>
                            </div>
                            <div className="table-header-subtitle-boxes-container">
                                <div>
                                    <img src="/static/img/file-search.svg" alt="img" />
                                </div>
                                <div className="table-header-subtitle-boxes-info">
                                    Impressions/Category
                                    <div className="table-header-subtitle-boxes-numbers">
                                        {numeral(this.props.avgImpressions).format('0.0a')}
                                    </div>{' '}
                                </div>
                            </div>
                            <div className="table-header-subtitle-boxes-container">
                                <div>
                                    <img src="/static/img/cursor-click-01.svg" alt="img" />
                                </div>
                                <div className="table-header-subtitle-boxes-info">
                                    Clicks/Category.
                                    <div className="table-header-subtitle-boxes-numbers">
                                        {numeral(this.props.avgClicks).format('0.0a')}
                                    </div>{' '}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default ExtraBox;
